import 'css-chunk:src/Home/Home.module.scss';export default {
  "card_title_img": "card_title_img__uX4BX",
  "logo": "logo__VgKB5",
  "fuwafuwa": "fuwafuwa__CzQWX",
  "fuwafuwa_sp": "fuwafuwa_sp__-F-ok",
  "test": "test__8q3-U",
  "bg": "bg__ypGb5",
  "text": "text__Ad4tY"
};